// authority.js
export default {
    forum_name: '论坛名称',
    search: '搜索',
    reset: '重置',
    status_closed: '关闭',
    status_open: '开启',
    index: '序号',
    name: '论坛名称',
    status: '状态',
    conduct_time: '开展时间',
    founder: '创办人',
    action: '操作',
    permission: '权限',
    confirm_delete: '确定删除该论坛吗？',
    delete_success: '删除成功',
    operation_success: '操作成功',
    input_forum_name: '请输入论坛名称',
    add_admin: '添加管理员',
    edit: '编辑',
    data_permission: '数据权限',
    delete: '删除',
    confirm_content: '确定删除该管理员吗？',
    user_id: '用户ID',
    real_name: '用户姓名',
    organization: '单位',
    email: '用户邮箱',
    mobile: '用户手机',
    role_name: '角色名称',
    ticket: '门票',
    select_all: '全选',
    article: '稿件',
    set_success: '设置成功',
    address: '论坛地址',
    to: '至',
    admin_edit_title: '编辑管理员',
    add_admin_title: '添加管理员',
    email_or_phone: '邮箱/手机号',
    input_email_or_phone: '请输入邮箱号或手机号查找用户',
    name_label: '姓名',
    input_name: '请输入姓名',
    organization_label: '单位',
    input_organization: '请输入单位',
    backend_role: '会议后台角色',
    select_backend_role: '请选择会议后台角色',
    permission_label: '权限：',
    all: '全部',
    select_all_label: '全选',
    custom: '自定义',
    select_permission_label: '请选择路由权限'
};
